<template>
  <soft-button color="success" variant="gradient" type='button' :disabled="disableButton" @click="handleClick">
    <div v-if="disableButton" class="spinner-loading" role="status">
      <span class="visually-hidden fs-1"></span>
    </div>
    {{ text }}
  </soft-button>
</template>
<script>

import SoftButton from "@/components/SoftButton.vue"
export default {
  name: "LoadingButton",
  components: {
    SoftButton,
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    disableButton: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ['import-file'],
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  methods: {
    handleClick() {
      this.$emit('import-file');
    }
  },
};
</script>
<style scoped>
.spinner-loading {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: -0.3em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}
</style>